/**
 * ridgewill.com, for the links the portal's frame shares with the site: the
 * lockup, Projects, Contact, Legal, and the footer.
 *
 * Production and staging link to ridgewill.com itself, which is the default
 * because there is no staging site. Dev builds set VITE_SITE_URL to the site's
 * dev deploy (.github/workflows/deploy.yml).
 */
export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://ridgewill.com').replace(/\/$/, '');
